import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import clsx from "clsx"
import LoadingDots from "./LoadingDots"

const Button = forwardRef(
  ({ children, className, isLoading, disabled, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={clsx("button", className)}
        disabled={disabled}
        {...rest}
      >
        {isLoading ? <LoadingDots /> : children}
      </button>
    )
  }
)

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
}

Button.defaultProps = {
  className: "",
  isLoading: false,
  disabled: false,
}

export default Button
